import { call, put, select, takeLatest } from 'redux-saga/effects';
import { searchProfiles } from '../../services/profileCallables';
import type { RootState } from '../store';
import {
  discoveryFailed,
  discoverySearchRequested,
  discoverySearchSucceeded,
} from '../slices/discoverySlice';

export function* handleDiscoverySearch(
  action: ReturnType<typeof discoverySearchRequested>,
): Generator<unknown, void, unknown> {
  try {
    const state = (yield select((s: RootState) => s.discovery)) as RootState['discovery'];
    const append = action.payload?.append ?? false;
    const result = (yield call(searchProfiles, {
      query: state.query,
      roleTypes: state.roleTypes,
      tags: state.tags,
      pageSize: 20,
      cursor: append ? state.nextCursor : null,
      includeAllTags: !append && state.allTags.length === 0,
    })) as Awaited<ReturnType<typeof searchProfiles>>;
    yield put(
      discoverySearchSucceeded({
        items: result.items,
        total: result.total,
        nextCursor: result.nextCursor,
        allTags: result.allTags,
        append,
      }),
    );
  } catch (e) {
    yield put(discoveryFailed(e instanceof Error ? e.message : 'Search failed'));
  }
}

export function* discoverySaga() {
  yield takeLatest(discoverySearchRequested.type, handleDiscoverySearch);
}
